// extracted by mini-css-extract-plugin
export default {"wrap":"Dots_wrap__X02h-","dot":"Dots_dot__FL12b","fade":"Dots_fade__6DTA4"};